module.exports = __webpack_public_path__ + "static/media/icon_credential_location.ffbe03e2.png";